import { PackageSearch } from "lucide-react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/shared/ui/core";


/**
 * Una categoría sin paquetes publicados.
 *
 * ── Por qué NO parece un error ───────────────────────────────────────
 * Nada de rojo ni de icono de alerta: que todavía no haya paquetes de una
 * categoría es un resultado normal —el catálogo se está armando— y
 * pintarlo como una falla hace que alguien reporte un problema que no
 * existe. La diferencia con el aviso de error tiene que verse a un metro
 * de la pantalla.
 *
 * ── Cada categoría vacía tiene su salida ─────────────────────────────
 * Sin paquetes personales no hay nada que la persona pueda hacer más que
 * volver, y ofrecerle un botón sería burlarse: se le manda a la tienda,
 * que sí tiene qué enseñarle. Sin paquetes de negocio digital la salida
 * SÍ existe y es la franquicia, que es lo que de verdad está buscando
 * quien abrió esa pestaña.
 */
export function PackagesEmpty() {
  const { t } = useTranslation();
  const isFranchisee = false;

  return (
    <div className="rounded-ds-xl border border-ds-border bg-white/70 px-6 py-16 text-center">
      <span className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-ds-lg border border-ds-lavender-bg-2 bg-ds-mist/40">
        <PackageSearch className="h-7 w-7 text-ds-lavender" aria-hidden="true" />
      </span>

      <p className="text-[15px] font-semibold text-ds-ink">
        {isFranchisee
          ? t("Todavía no hay paquetes de negocio digital publicados")
          : t("Todavía no hay paquetes personales publicados")}
      </p>

      <p className="mx-auto mt-2 max-w-sm text-[13px] leading-relaxed text-ds-ink-3">
        {isFranchisee
          ? t(
              "Estos paquetes son para quien ya tiene su franquicia digital. Mientras los preparamos, puedes conocer cómo funciona.",
            )
          : t("Estamos armando los paquetes. Mientras tanto, mira el catálogo completo.")}
      </p>

      <Button
        as={Link}
        to={isFranchisee ? "/franquicias" : "/shop"}
        variant="dark"
        size="sm"
        className="mt-6"
      >
        {isFranchisee ? t("Ver franquicias") : t("Ir a la tienda")}
      </Button>
    </div>
  );
}
